import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Subject } from 'rxjs';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class StatsService {
  totalLength = 0;
  hmoNotAssign =[]
  statsForm;
  usersStats = [];
  users =[];
  HMO = ['Macabi', 'Leumit', 'Meuhedet', 'Clalit', 'Private' ]
  code;
  Params;
  isGastro;
  isCardio;
  examsArray = [];
  statsLoaded$ = new Subject();
  CARDIO = ['TTE Adults', 'Stress', 'Stress-Echo','Duplex Carotid', 'All']
  GASTRO = ["Gastroscopy", "Colonoscopy", "Sigmoidoscopy","Abdomen US", "Hemorrhoids Treatment", "All"];
  GASTROFORMS=[ 'Admission', 'TimeOut', 'AllForms']
  GYN =[ '1st', 'NT', 'Early', '2nd/3rd','Weight Assessment','Tech Exam', 'Late', 'Specialized' ,'Fetal Echo', 'Gynecology', 'Follicles', 'CVS', 'Amniocentesis','Emergency Room', 'All'];
  INVASIVE =[  'CVS', 'Amniocentesis',  'AllInvasive']
  constructor(private http:HttpClient, private fb: UntypedFormBuilder, private ls:LoginService) { 
    this.resetForm();
    
  }
  resetForm(){
    this.statsForm = this.fb.group({
      Colonoscopy:[''],
      Gastroscopy:[''],
      Sigmoidoscopy:[''],
      Gynecology :[''],
      CVS :[''],
      Amniocentesis :[''],
      Follicles:[''],
      first:[''],
      NT:[''],
      Early:[''],
      second:[''],
      WeightAssessment:[''],
      TechExam:[''],
      Late:[''],
      Specialized:[''],
      FetalEcho:[''],
      All:[''],
      start:[''],
      end:[''],
      exams:[''],
      Admission:[''],
      TimeOut:[''],
      AllForms:[''],
      examsUsers:[''],
      formsUsers:[''],
      TTEAdults:[''],
      Stress:[''],
      DuplexCarotid:[''],
      StressEcho:[''],
      EmergencyRoom:[''],
      AbdomenUS:[''],
      HemorrhoidsTreatment:[''],
      
    })
  }

  search(params, code=null){
    if(code){
      this.code = code;
      this.loadData(code)
    }
    this.Params = params;
    // this.Params['isGastro'] = this.ls.isGastro
    this.http.get('/api/stats', {'params':params}).subscribe((data) => {
      this.resetForm();
      if(params.end && params.start){
        this.statsForm.get('start').setValue(params.start)
        this.statsForm.get('end').setValue(params.end)
      }else{
        this.statsForm.patchValue(data)
      }
      // this.isGastro = data['isGastro'];
      if(data['type'] =='CARDIO'){
        this.ls.isCardio = true;
        this.ls.isGastro = false;
        this.examsArray = this.CARDIO;
      }
      else if(data['type'] =='GASTRO'){
        this.ls.isGastro = true;
        this.ls.isCardio = false;
        this.examsArray = this.GASTRO;
      }else{
        this.ls.isGastro = false;
        this.ls.isCardio = false;
        this.examsArray = this.GYN;
      }
      this.filterData(data);
      this.statsLoaded$.next(undefined)
    })
    
  }
  filterByHMO(data,hmo){
    if(!data)
      return []
    var temp = data;
    this.hmoNotAssign = temp.filter((i) => i.HMO ==null)
    return temp.filter((i) => i.HMO ==hmo)
    // if(temp.length > 0 ){
    // }
    // return temp
    
  }

  filterData(data){
    this.usersStats = data['data'];
      let name
      if(data['All']){
        var exams = data['All'];
        this.totalLength = exams.length;
        this.statsForm.get('All').setValue(exams);
        for(let i=0; i<this.GASTRO.filter((i)=> i !='All').length; i++){
          name = this.GASTRO[i].replace(' ', '');
          this.statsForm.get(name).setValue(exams.filter((exam) => exam.ExamType == this.GASTRO[i]))
        }
        
      }
      if(data['AllForms']){
        this.statsForm.get('AllForms').setValue(data['AllForms']);
        this.statsForm.get('Admission').setValue(data['All'].filter((i) => i.FormName =='Admission Form'))
        this.statsForm.get('TimeOut').setValue(data['All'].filter((i) => i.FormName =='Time Out Form'))
      }
      return;
    
    
  }
  loadData(code){
    this.code = code;
    this.http.post('/api/print/resurection', {code:code}).subscribe((data) => {
      this.search(this.Params);
    })
  }

}
